import { ReactComponent as LeftArrowIcon } from 'assets/icons/orangeLeftArrow.svg';
import { ReactComponent as NoFoldersAndFiles } from 'assets/icons/noFoldersorFiles.svg';

import { Table, Tooltip } from '@mantine/core';

// import useGetFolders from '../../hooks/useGetFolders';
import useGetIntoFolders from '../../hooks/useGetIntoFolder';
import ModalFoldersAndFilesTable from './modalFoldersAndFilesTable';
import PrimaryButton from 'components/primaryButton';
import { useState } from 'react';
import AddNewSubFolderModal from './addNewSubFolderModal';

const ModalSubFolders = ({
  historyOfPath,
  setHistoryOfPath,
  mainPath,
  setMainPath,
  setSelectedId,
}) => {
  const pathFilesAndFolders = useGetIntoFolders(historyOfPath);

  const rows = pathFilesAndFolders?.data?.data?.map((each) => (
    <ModalFoldersAndFilesTable
      data={each}
      historyOfPath={historyOfPath}
      setHistoryOfPath={setHistoryOfPath}
    />
  ));

  const foldername = historyOfPath?.split('/').pop();

  const exitFromFolder = historyOfPath?.split('/');

  const exitFromFolder_01 = exitFromFolder?.slice(0, exitFromFolder.length - 1);

  const [addSubFolderModal, setAddSubFolderModal] = useState(false);

  return (
    <>
      <div className=' bg-[#ffffff] min-h-[68vh]'>
        <div className='flex justify-between items-center mt-2'>
          <h1 className='flex items-center gap-2 text-[#333333] font-semibold'>
            <Tooltip
              label={'Back'}
              wrapLines
              classNames={{
                body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
              }}
              radius='md'
            >
              <LeftArrowIcon
                className='h-5 w-8 cursor-pointer'
                onClick={() => {
                  if (historyOfPath === mainPath) {
                    setHistoryOfPath(null);
                    setSelectedId(null);
                  } else {
                    setHistoryOfPath(exitFromFolder_01?.join('/'));
                  }
                }}
              />
            </Tooltip>

            {foldername}
          </h1>
          <button className='pr-5' onClick={() => setAddSubFolderModal(true)}>
            <PrimaryButton>+ New folder</PrimaryButton>
          </button>
        </div>
        <div className='mt-4'>
          <Table verticalSpacing='lg' highlightOnHover>
            <thead>
              <tr>
                <th
                  className='bg-[#FFE8E1] rounded-tl-xl w-4/12'
                  style={{ textAlign: 'start', paddingLeft: '40px' }}
                >
                  Name
                </th>

                <th
                  className='bg-[#FFE8E1] '
                  style={{ textAlign: 'right', paddingRight: '50px' }}
                >
                  Action
                </th>
                <th className=' bg-[#FFE8E1]' style={{ textAlign: 'center' }}>
                  Modified
                </th>

                <th
                  className='bg-[#FFE8E1] rounded-tr-xl'
                  style={{ textAlign: 'center' }}
                >
                  Modified by
                </th>
              </tr>
            </thead>

            <tbody className=' w-full max-h-20 border-none'>{rows}</tbody>
          </Table>
          {pathFilesAndFolders?.data?.data?.length === 0 && (
            <div className='flex justify-center items-center my-4 py-5 flex-col'>
              <NoFoldersAndFiles style={{ height: '180px', width: '180px' }} />
              <p className='text-gray mt-4 text-[18px]'>
                No folder or files to show
              </p>
            </div>
          )}
        </div>
      </div>
      <AddNewSubFolderModal
        addSubFolderModal={addSubFolderModal}
        setAddSubFolderModal={setAddSubFolderModal}
        name='Modal'
        historyOfPath={historyOfPath}
      />
    </>
  );
};

export default ModalSubFolders;
